import React from'react';import{i18n}from'@shopgate/engage/core';/**
 * The Coupon Free Shipping component.
 * @param {Object} props The component props.
 * @returns {JSX}
 */export function CartItemCouponFreeShipping(_ref){var freeShipping=_ref.freeShipping;if(!freeShipping){return null;}return React.createElement("div",null,i18n.text('cart.free_shipping'));}CartItemCouponFreeShipping.defaultProps={freeShipping:false};